import { render, staticRenderFns } from "./StudentCategoriesCreate.vue?vue&type=template&id=56e7bdbb&scoped=true&"
import script from "./StudentCategoriesCreate.vue?vue&type=script&lang=ts&"
export * from "./StudentCategoriesCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7bdbb",
  null
  
)

export default component.exports